import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { DecodeHtmlPipe } from './decode-html.pipe';
import { FilterDecevalPipe } from './filter-decevals.pipe';
import { FilterSelectPipe } from './filter-select.pipe';
import { OrderByPipe } from './order-by.pipe';
import { ThousandSeparatorPipe } from './thousand-separator.pipe';
import { FilterOptionsPipe } from './search-select.pipe';
import { CustomCapitalizePipe } from './custom-capitalize.pipe';
import { DateTransformPipe } from "./date-transform.pipe";
import { TermPipe } from './term.pipe'
import { CurrencyPipe } from './currency-co.pipe';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';
import { translateFrequencyPipe } from './translateFrequency.pipe';
import { MonthsPipe } from './months.pipe';
import { RateMaskPipe } from '@pipes/rate-mask.pipe';
import { ExcludeTermPipe } from './exclude-term.pipe';
import { FechaLargaPipe } from './fecha-larga.pipe';

registerLocaleData(localeEs, 'es-ES', localeEsExtra);

@NgModule({
  providers: [
    { provide: LOCALE_ID, useValue: 'es-ES' }
  ],
  declarations: [
    ThousandSeparatorPipe,
    OrderByPipe,
    FilterSelectPipe,
    FilterDecevalPipe,
    DecodeHtmlPipe,
    FilterOptionsPipe,
    CustomCapitalizePipe,
    DateTransformPipe,
    TermPipe,
    translateFrequencyPipe,
    CurrencyPipe,
    MonthsPipe,
    RateMaskPipe,
    ExcludeTermPipe,
    FechaLargaPipe
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    ThousandSeparatorPipe,
    OrderByPipe,
    FilterSelectPipe,
    FilterDecevalPipe,
    DecodeHtmlPipe,
    FilterOptionsPipe,
    CustomCapitalizePipe,
    DateTransformPipe,
    TermPipe,
    translateFrequencyPipe,
    CurrencyPipe,
    MonthsPipe,
    RateMaskPipe,
    ExcludeTermPipe,
    FechaLargaPipe
  ]

})
export class PipesModule { }
